<template>
    <div class="pkgs-versions">
        <ul>
            <li><b>NUGET</b></li>
            <li v-for="(value, text, index) in items" :key="index">
                <rd-header type="secondary" :title="`${text}: ${value}`" />
            </li>
        </ul>
        <ul>
            <li><b>NPM</b></li>
            <li v-for="(value, name, index) in $store.getters.packageVersions" :key="index">
                <rd-header type="secondary" :title="`${name.charAt(0).toUpperCase() + name.slice(1)}: ${value}`" />
            </li>
        </ul>
    </div>
</template>
<script>
import { mapActions } from "vuex";

// stores
import { INDEX_STORE } from "../storeNames";

export default {
  name: "PackagesVersions",
  data() {
    return {
      items: [],
    };
  },
  methods: {
    ...mapActions(INDEX_STORE, ["setPackagesVersions"]),
  },
  mounted() {
    this.setPackagesVersions().then((response) => {
      this.items = response.data;
    });
  },
};
</script>
<style scoped lang="scss">
    .pkgs-versions {
        display: flex;
        ul {
            list-style-type: none;
            margin: 0;
            padding-left: 0;
        }
    }

</style>
